import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

let el_pageContainer = document.getElementById( "page-wrapper" ),
    el_header = document.getElementById( "page-header" ),
    // el_mobileNavMenu = document.querySelector( "#page-header nav" ),
    el_mobileNavMenu = document.querySelector( "#main-nav-mobile nav" ),
    // el_mobileAccountMenu = document.querySelector( "#page-header .account .menu" ),
    el_mobileAccountMenu = document.querySelector( "#account-nav-mobile nav" ),
    Menus = [ "account", "navigation" ];

// TODO: manage body scroll lock on resize
// * currently could end up in a "stuck" state if the user opens a menu iFn Mobile/Tablet view, switches to Desktop and tries to scroll
// * revisit: openAccountMenu and openNavMenu
const ResponsiveViews = [ "mobile", "tablet", "desktop" ]; // todo: refactor this to use BREAKPOINTS

function isMobile() {
    return window.matchMedia( "( max-width: 1439px )" ).matches;
}

export default () => ({
    isLoggedIn: false,
    openMenu: null,
    cachedResponsiveView: ResponsiveViews[ 0 ], // default to Mobile


    allowTouchMove ( element ) {
        // console.log( { element } );
        let _element = element;
        while (_element && _element !== document.body) {
            if (_element.getAttribute('body-scroll-lock-ignore') !== null) {
                return true;
            }
            _element = _element.parentElement;
        }
    },

    menuIsOpen () {
        return !!this.openMenu;
    },
    offCanvasMenuIsOpen() {
        return !!this.openMenu && isMobile();
    },

    navMenuIsOpen () { return this.openMenu == "navigation"; },
    accountMenuIsOpen () { return this.openMenu == "account"; },
    dropDownIsOpen() {
        // this is a placeholder in anticipation of multiple Desktop navbar dropdowns
        if ( isMobile() ) {
            return false;
        }
        // right now, there's only the Account Menu that qualifies
        return this.accountMenuIsOpen();
    },

    onClickMenuToggle() {
        /* Menu toggle works to:
           * open the Mobile Nav menu, if:
           * - it is closed
           * - and no other menu is open
           * close the Mobile Nav menu, if:
           * - it is open
           * close the Account menu, if:
           * - it is open
         */
        if ( !this.openMenu ) {
            // open "navigation"
            this.openNavMenu();
            return;
        }

        // close whatever is open
        this.closeMenuByToken( this.openMenu );
    },

    onMouseenterAccount( event ) {
        if ( isMobile() ) { return; }
        if ( this.openMenu != "account" ) {
            this.closeMenuByToken( this.openMenu );
            this.openAccountMenu();
        }
    },
    onMouseleaveAccount( event ) {
        if ( isMobile() ) { return; }
        if ( this.openMenu == "account" ) {
            this.closeMenuByToken( 'account' );
        }
    },
    onHoverAccountMenuToggle ( event ) {
        if ( this.openMenu != "account" ) {
            this.openAccountMenu();
            return;
        } else {
            this.closeMenuByToken( this.openMenu );
        }

    },
    onClickAccountMenuToggle( event ) {
        /* Account Menu Toggle works to:
        * open the Account menu, if:
        * - it is closed
        * close the Account menu, if:
        * - it is open,
        * - and the site is not in Mobile view (where the main menu toggle would close it)
        */
        // console.log( "onClickAccountMenuToggle", { "isMobile": isMobile(), "openMenu": this.openMenu } );

        if ( this.openMenu != "account" ) {
            this.closeMenuByToken( this.openMenu );
            this.openAccountMenu();
            return;
        } else {
            this.closeMenuByToken( this.openMenu );
        }

    },
    onClickOutsideNavbar() {
        Menus.forEach( current => {
            if ( this.openMenu == current ) {
                this.closeMenuByToken( current );
            }
        } );
    },
    closeMenuByToken( token ){
        switch ( token ) {
            case "navigation":
                enableBodyScroll( el_mobileNavMenu );
                break;
            case "account":
                enableBodyScroll( el_mobileAccountMenu );
                break;
        }
        this.openMenu = null;
    },

    openNavMenu() {
        this.openMenu = "navigation";
        if ( isMobile() ) {
            // console.log( "disableBodyScroll!" );
            // disableBodyScroll( el_mobileNavMenu );
            disableBodyScroll( el_mobileNavMenu, {
                allowTouchMove: this.allowTouchMove,
            });
        }
    },

    openAccountMenu() {
        this.openMenu = "account";
        if ( isMobile() ) {
            // console.log( "disableBodyScroll!" );
            // disableBodyScroll( el_mobileAccountMenu );
            disableBodyScroll( el_mobileAccountMenu, {
                allowTouchMove: this.allowTouchMove,
            });

        }
    },

    getResponsiveView() {
        if ( isMobile() ) { return ResponsiveViews[ 0 ]; }
        return ResponsiveViews[ 2 ]; // defaults to Desktop
    },

    onResizeWindow( event ) {
        let self = this;

        let newResponsiveView = self.getResponsiveView();

        if ( newResponsiveView === self.cachedResponsiveView ) {
            // views are the same, bail.
            return;
        }

        // cache the new view
        self.cachedResponsiveView = newResponsiveView;

        // do the things
        if ( !!this.openMenu ) {
            if ( self.cachedResponsiveView === ResponsiveViews[ 0 ] ) {
                // is now Mobile
                // allow the menu to remain open but kill the scroll
                // console.log( `%cMobile! The open menu was "${ this.openMenu }"`, `font-size: 24px; font-weight: 700; color: rebeccapurple;` );

                switch ( this.openMenu ) {
                    case "navigation":
                        // disableBodyScroll( el_mobileNavMenu );
                        disableBodyScroll( el_mobileNavMenu, {
                            allowTouchMove: this.allowTouchMove,
                        });
                        break;
                    case "account":
                        // disableBodyScroll( el_mobileAccountMenu );
                        disableBodyScroll( el_mobileAccountMenu, {
                            allowTouchMove: this.allowTouchMove,
                        });
                        break;
                }

            } else {
                // is now Not
                // allow the menu to remain open but enable the scroll
                // console.log( `%cDesktop! The open menu was "${ this.openMenu }"`, `font-size: 24px; font-weight: 700; color: red;` );
                switch ( this.openMenu ) {
                    case "navigation":
                        enableBodyScroll( el_mobileNavMenu );
                        break;
                    case "account":
                        enableBodyScroll( el_mobileAccountMenu );
                        break;
                }

            }
        }

    },

    init() {
        let self = this;

        window.addEventListener( "resize", Alpine.debounce( self.onResizeWindow.bind( self ), 100 ) );

    }

})
